import { render, staticRenderFns } from "./SupportingCaregivers.vue?vue&type=template&id=5a7c08c4&"
import script from "./SupportingCaregivers.vue?vue&type=script&lang=js&"
export * from "./SupportingCaregivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports